import 'froala-editor/js/froala_editor.pkgd.min.js';
import 'froala-editor/js/plugins.pkgd.min.js';

import PerfectScrollbar from 'perfect-scrollbar';

//Sweet Alert
//window.swal = require('sweetalert2');

// Clipboard JS
//window.ClipboardJS = require('clipboard');
window.CodeMirror = require('codemirror');
window.FroalaEditor = require('froala-editor');
window.moment = require('moment');
window.numeral = require('numeral');
window.PerfectScrollbar = PerfectScrollbar;
window.pubsub = require('pubsub.js');
window.uniqid = require('uniqid');
window.URI = require('urijs');

require('./bootstrap');
require('mdbootstrap-pro');

//require('active-timeout');
require('bootstrap-colorpicker');
//require('cleave.js');
//require('donleeve');
require('icheck');
require('jquery-validation');
//require('jquery-form');
//require('jquery-match-height');
//require('select2');
require('slick-carousel');
//require('waypoints');


require('./components/MenuEditor/App');
require('./components/TourOrderer/App');
require('./components/Media/index');
require('./components/LiveCodeEditor');


// WEBPACK FOOTER //
// ./resources/js/app.js